module.exports = __webpack_public_path__ + "static/media/meitlogo.bfb22867.jpg";